'use client';

import {useIdleTimeout} from '@/lib/useIdleTimeout';
import {UserFlowStage, useUserFlow} from '@/lib/UserFlow';
import IdleNotification from '@/components/IdleNotification';

export default function IdleTimeoutHandler() {
    const { stage, reset } = useUserFlow();
    const isInFlow = stage !== UserFlowStage.Idle && stage !== UserFlowStage.ThankYou;

    const { isIdleNotificationVisible } = useIdleTimeout({
        enabled: isInFlow,
        onTimeout: reset,
    });

    if (!isIdleNotificationVisible) return null;

    return (
        <IdleNotification
            open={isIdleNotificationVisible}
        />
    );
}
